import React from "react";
import RosterGrid from "./roster/RosterGrid";

export default function UserSchedulesTab() {
  return <RosterGrid />;
}
